import React from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'

const EditSpecialtiesModal = (props) => {

    const customStyles = {
        content: {
            width: "60%",
        }
    }

    return (
        <ReactModal
            isOpen={props.modalIsOpen}
            onRequestClose={props.closeModal}
            contentLabel="Editar especialidad"
            className="custom-modal"
            ariaHideApp={false}
            style={customStyles}
        >
            <span className="custom-modal__close close-btn" onClick={props.closeModal}><CloseBtn /></span>
            <h4 className="custom-modal__title">Editar especialidad</h4>
            <Form className="products__form">
                <div>
                    <Form.Group controlId="product-name">
                    <Form.Label className="form__labels">Nombre <RequieredInputs/> </Form.Label>
                        <Form.Control className="user-input name"
                            type="text"
                            name="nombre"
                            value={props.editSpecialty.nombre}
                            onChange={props.handleChange}
                            placeholder="Introduce el cargo"
                        />
                    </Form.Group>
                </div>
                <button onClick={e => props.handleSubmitToUpdate(e, props.editSpecialty)} disabled={!props.validateForm()} className="btn save create">{props.textBtn}</button>
            </Form>
        </ReactModal>
    )
}

export default EditSpecialtiesModal